import { useTranslation } from 'react-i18next';
import type { MemberRole } from '@repo/shared-types';

export function RolePill({ role }: { role: MemberRole }) {
  const { t } = useTranslation('common');
  return (
    <span className="shrink-0 rounded-sm bg-brand-50 px-1.5 py-0.5 text-[10px] font-bold uppercase tracking-wider text-brand-700">
      {t(`orgMenu.role.${role}`)}
    </span>
  );
}
